import Logo from 'assets/img/chroniker.co.png';
// https://developer.mozilla.org/en-US/docs/Web/API/Notifications_API/Using_the_Notifications_API
// https://developer.mozilla.org/en-US/docs/Web/API/Notification
// https://javascript.info/class
// TODO onclick focus opened windows
// https://stackoverflow.com/questions/31512504/html5-notification-not-working-in-mobile-chrome/31787926
// ADAPT TO MOBILE

class BrowserNotification {
  options = {
    vibrate: [200, 100, 200],
    requireInteraction: false,
    icon: Logo,
    body: 'Sample Text',
  };

  config = {
    title: 'Chroniker',
    timeout: 5000,
  };

  static async getRegistration() { // Made static
    if (process.env.NODE_ENV === 'production') {
      return navigator.serviceWorker.ready;
    }
    return null;
  }

  static async closeNotifications(timeout = 0) { // Made static
    if (process.env.NODE_ENV === 'production') {
      const registration = await BrowserNotification.getRegistration(); // Used static method
      if (registration) {
        const notifications = await registration.getNotifications();
        setTimeout(() => {
          notifications.map((notification) => notification.close());
        }, timeout);
      }
    }
  }

  requestNotificationPermissions = () => {
    const notificationPermissions = async () => {
      const permission = await Notification.requestPermission();
      if (permission === 'denied') {
        console.warn('Notifications are blocked. Please enable them in your browser settings.'); // Changed alert to console.warn
      }
    };
    notificationPermissions();
  };

  sendNotification = (body) => {
    const send = async () => {
      if (Notification.permission === 'granted') {
        const notificationOptions = { ...this.options };
        if (body) {
          notificationOptions.body = body;
        }

        if (process.env.NODE_ENV === 'production') {
          // Production: Use Service Worker
          await BrowserNotification.closeNotifications(); // Changed to static call
          const registration = await BrowserNotification.getRegistration(); // Used static method
          await registration.showNotification(this.config.title, notificationOptions);
          await BrowserNotification.closeNotifications(this.config.timeout); // Changed to static call
        } else {
          // Development: Use standard Notification API
          const notification = new Notification(this.config.title, notificationOptions);
          setTimeout(() => {
            notification.close();
          }, this.config.timeout);
        }
      }
    };
    send();
  };
}

const notificationInstance = new BrowserNotification();
export default notificationInstance;
